// extracted by mini-css-extract-plugin
module.exports = {"video":"videoMauro_video__fvXQV","top":"videoMauro_top__zwHUt","content":"videoMauro_content__dpC3f","bottom":"videoMauro_bottom__u7zQd"};